export function isPromise(obj) {
    return !!obj && ("object" == typeof obj || "function" == typeof obj) && "function" == typeof obj.then;
}
//# sourceMappingURL=promise.js.map
